// find.js
export const findPlanForType = (plans, type) => {
  const t = (type || '').toLowerCase();

  // 1) id contains type (legacy)
  const byId = plans.find(p => String(p.id || '').toLowerCase().includes(t));

  // 2) authoritative API field
  const byType = plans.find(
    p => String(p.dataType ?? p.data_type ?? '').toLowerCase() === t
  );

  // If neither found, DO NOT pick a plan from another type
  return byId || byType || null;
};
